import MediaList from './MediaList';
import MediaItem from '../upload/MediaItem';
import MediaLibrary from "../upload/MediaLibrary";


class MediaSelectableList extends MediaList {
    constructor(element, onMediaChange) {
        super(element);
        this.onMediaChange = onMediaChange;

        this.mediaChange = this.mediaChange.bind(this);

        // listen for when a user clicks an item
        MediaLibrary.list.forEach(media => {
            media.html.click(this.mediaChange);
            media.checkbox.input.onchange = this.mediaChange;
        });
    }

    selectFiles(files) {
        this.unselectAll();
        files.forEach(file => this.selectRow(file.key));
    }

    unselectAll() {
        for(const key in MediaLibrary.keyList) {
            this.unselectRow(key);
        }
    }

    toggleSelectRow(key) {
        const media = MediaLibrary.get(key);

        if(media) {
            media.checkbox.input.checked = !media.checkbox.input.checked;
        }
    }

    selectRow(key) {
        const media = MediaLibrary.get(key);

        if(media) {
            media.checkbox.input.checked = true;
        }
    }

    unselectRow(key) {
        const media = MediaLibrary.get(key);

        if(media) {
            media.checkbox.input.checked = false;
        }
    }

    mediaChange(evt) {
        const target = evt.currentTarget;

        if(this.onMediaChange) {
            this.onMediaChange(evt);
        }

        const key = target.getAttribute('data-key');
        this.toggleSelectRow(key);

        evt.preventDefault();
        evt.stopPropagation();
    }
    
    fillTemplate(key, name, when) {
        const templateHtml = this.generateTemplate(key);
        const template = this.createMediaItem(templateHtml, key, name, when);
        return template.html;
    }

    generateTemplate(key) {
        const html = $('#media-template')
            .clone()
            .attr('id', null)
            .removeClass('hide')
            .addClass('media')
            .attr('data-key', key)
            .click(this.mediaChange.bind(this));

        return html
    }

    createMediaItem(html, key, name, when) {
        const tds = html.find('td');

        if(tds.length < 3) {
            // Failsafe: If this is running, someone broke the template
            throw new Error("Cannot find td in template. Is template missing/modified?");
        }

        const checkboxGroup = tds[0].children[0];
        const checkbox = {
            group: checkboxGroup,
            input: checkboxGroup.children[0],
            label: checkboxGroup.children[1],
        };

        const mediaItem = new MediaItem(html, name, when);
        
        const nameField = tds[1];
        nameField.textContent = name;

        const whenField = tds[2];
        whenField.textContent = when;

        checkbox.input.checked = true;

        // initialize the checkbox
        checkbox.input.setAttribute('id', 'media-' + key);
        checkbox.label.setAttribute('for', 'media-' + key);

        // allow mediaitem to carry the checkbox data as a property
        mediaItem.checkbox = checkbox;

        return mediaItem;
    }
}


export default MediaSelectableList;